export * from '@fhs/routing/src/routes/v2/menu/(menu)/[slug]/_layout';
export { default } from '@fhs/routing/src/routes/v2/menu/(menu)/[slug]/_layout';
